// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAdBsU2oEoMKrDhNzpJb379VKpGfN3PqHQ",
  authDomain: "coderpixelinnovations.firebaseapp.com",
  databaseURL: "https://coderpixelinnovations-default-rtdb.firebaseio.com",
  projectId: "coderpixelinnovations",
  storageBucket: "coderpixelinnovations.firebasestorage.app",
  messagingSenderId: "1093908585788",
  appId: "1:1093908585788:web:b0a5b3860b9e50c4e75239",
  measurementId: "G-GQ1C9V537K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const database = getDatabase(app);
export const storage = getStorage(app);
export { app };